<template>
  <div id="contract-redeem">
    <b-row>
      <b-col cols="6">
        <div class="label-1">{{ $t('REDEEM_CONTRACT') }}<template v-if="step==3"> - {{ $t('SUCCESS') }}</template></div>
        <div v-if="step==1" class="label-2">{{ $t('OVERVIEW') }}</div>
        <div v-else-if="step==2" class="label-2">{{ $t('BILL') }}</div>
      </b-col>
      <b-col cols="3"></b-col>
      <b-col cols="3">
        <step-progress v-model="step" :steps="steps"/>
      </b-col>
    </b-row>
    <window-stepper @cancel="cancel" class="content" v-model="step" :steps="componentSteps"/>
  </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api';
import StepProgress from '@/components/StepProgress';
import WindowStepper from '@/components/WindowStepper';
import { createNamespacedHelpers } from 'vuex-composition-helpers';
import { CONTRACT_STATUSES as STATUSES } from '@/consts';

import FormStep from './StepComponents/FormStep';
import PrintStep from './StepComponents/PrintStep';
import CompleteStep from './StepComponents/CompleteStep';

const { useState } = createNamespacedHelpers('contractRedeem');
const { useActions: useFlashActions } = createNamespacedHelpers('flash');

const steps = ['Bước 1', 'Bước 2'];

export default {
  name: 'ContractRedeem',
  components: {
    StepProgress,
    WindowStepper,
  },
  metaInfo() {
    const { $i18n, $root: { $route } } = this;

    const title = `${$i18n.t('REDEEM_CNTRCT_NUMBER')} #${$route.params.id}`;

    return {
      title,
      meta: []
    };
  },
  setup(_, { root }) {
    const contractMifosId = Number.parseInt(root.$route.params.id, 0);

    const { info } = useState(['info']);

    const step = ref(1);

    const componentSteps = [FormStep, PrintStep, CompleteStep];

    const { error } = useFlashActions(['error']);

    const cancel = () => {
      root.$router.push({ name: 'contract-detail', params: { id: contractMifosId } });
    };

    watch(step, () => window.scrollTo(0, 0));

    watch(info, () => {
      if (!info.value.active) {
        root.$router.push({ name: 'contract-detail', params: { id: contractMifosId } });
        error(root.$t('REDEEM_ERROR'));
      }
      if (info.value.status === STATUSES.CLOSED) {
        root.$router.push({ name: 'contract-detail', params: { id: contractMifosId } });
        error(root.$t('REDEEM_CLOSED_ERROR'));
      }
      if (info.value.mifosId !== contractMifosId) {
        root.$router.push({ name: 'contract-redeem', params: { id: info.value.mifosId } });
      }
    });

    return {
      steps,
      step,
      componentSteps,
      cancel,
    };
  },
};
</script>

<style lang='scss' scoped>
@import "~@/assets/scss/colors";

#contract-redeem {
  padding: 32px 30px;
  .label-1 {
    font-size: 28px;
    text-transform: capitalize;
    color: $independence;
  }

  .label-2 {
    font-size: 20px;
    text-transform: capitalize;
    color: $dove;
  }

  .content {
    margin-top: 48px;
  }
};
</style>
